import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

/**
 * @typedef {import ('../../../interfaces/services/IUser.interface').ILoginForm} ILoginForm
 */
const defaultValues = {
  user: '',
  password: '',
};

const resolver = yupResolver(
  yup.object().shape({
    user: yup.string().required('Campo obligatorio'),
    password: yup.string().required('Campo obligatorio'),
  })
);

export { defaultValues, resolver };
